import { render, staticRenderFns } from "./manage-send-stat.html?vue&type=template&id=799458d2&scoped=true&external"
import script from "./manage-send-stat.js?vue&type=script&lang=js&external"
export * from "./manage-send-stat.js?vue&type=script&lang=js&external"
import style0 from "./manage-send-stat.scss?vue&type=style&index=0&id=799458d2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799458d2",
  null
  
)

export default component.exports